import { render } from "./BasicProductionGraphic.vue?vue&type=template&id=05f96d86"
import script from "./BasicProductionGraphic.vue?vue&type=script&lang=js"
export * from "./BasicProductionGraphic.vue?vue&type=script&lang=js"

import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__